import { inject, Injectable, OnDestroy, signal } from '@angular/core';
import { Observable, startWith, Subject, Subscription, switchMap, timer } from 'rxjs';
import { AllStatus } from '../status/all-status';
import { NotificationService } from '../Notification/notification';
import { LanguageService } from '../language/language.service';

@Injectable({
  providedIn: 'root'
})
export class Downtime implements OnDestroy {
  reset$ = new Subject();
  sub: Observable<number>;
  subscription: Subscription;
  val= signal<number>(0);
  allStatus = inject(AllStatus);
  notification = inject(NotificationService);
  isShowNotification: boolean = false;
  langService = inject(LanguageService);
  
  ngOnDestroy(): void {
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    this.refreshTimer();
  }

  init(limit: number = 900): void{
    //let limit = 420;
    this.initialize();
    this.subscription = this.sub.subscribe(val => {
      this.val.set(val);
      if(this.val() === (limit - 300) && !this.isShowNotification){
        let txt = (this.langService.appLanguage === 'uk')?'Ви ще тут? До завершення сесії залишилось 5 хв.':(this.langService.appLanguage === 'ru')?'Вы ещё здесь? До завершения сессии осталось 5 мин.':'Still here? Your session will expire in 5 min.';
        this.notification.setMessage(txt);
        this.notification.display(300000);
        this.isShowNotification = true;
      }
      if(this.val() === limit){
        this.allStatus.setDownTime(true);
      }
    });
  }

  initialize(): void {
    this.sub = this.reset$.pipe(
      startWith(0),
      switchMap(() => timer(1000, 1000))
    );
  }

  refreshTimer(): void {
    this.isShowNotification = false;
    this.notification.closed();
    this.reset$.next(0);
  }
  
}
